import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useUser } from '../../context/UserContext.tsx';
import { logUserActivity } from '../../services/player/LoginService.tsx';

function NavigateUserComponent() {
  const { user, userIpData } = useUser();
  const location = useLocation();
  const navigate = useNavigate();
  const [width, setWidth] = useState(window.innerWidth);
  const [linkTo, setLinkTo] = useState(() =>
    window.innerWidth < 1000 ? "/bets/figures" : "/bets/figures"
  );

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
      let newLink;
      if (window.innerWidth < 1000) {
        newLink = "/bets/figures";
      } else {
        newLink = "/bets/figures";
      }
      if (newLink !== linkTo) {
        setLinkTo(newLink);
        navigate(newLink);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [linkTo, navigate]);

  useEffect(() => {
    if (user) {
      let actionName = "";
      if (location.pathname.startsWith("/bets/calendar/month")) {
        actionName = "View History";
      } else if (location.pathname === "/bets/figures") {
        actionName = "View History";
      } else if (location.pathname === "/bets") {
        actionName = "View Pending";
      } else if (location.pathname === "/bets/update") {
        actionName = "View Transaction";
      }

      if (actionName) {
        logUserActivity(user.userName, actionName, userIpData);
      }
    }
  }, [user, location.pathname]);

  const isActive = width < 1000
    ? location.pathname === "/bets/figures"
    : location.pathname.startsWith("/bets/calendar");

  return (
    <div className='button-container mt-lg-5 mb-lg-2'>
      {/* <Link to={linkTo} className={`button ${isActive ? "active" : ""}`}>
        <span className='option'>History</span>
      </Link> */}
      <Link to={linkTo} className={`button ${location.pathname === "/bets/figures" ? "active" : ""}`}>
        <span className='option'>History</span>
      </Link>
      <Link to="/bets" className={`button ${location.pathname === "/bets" ? "active" : ""}`}>
        <span className='option'>Pending</span>
      </Link>
      <Link to="update" className={`button ${location.pathname === "/bets/update" ? "active" : ""}`}>
        <span className='option'>Transactions</span>
      </Link>
    </div>
  )
}

export default NavigateUserComponent;